import React from 'react';
import PropTypes from 'prop-types';
import css from './Switch.scss';
import ReactSwitch from 'react-switch';
import Icon from 'SF/MaterialIcon';
import classnames from 'classnames';
import { isEmptyString } from '../utils/text';
import { omit } from 'lodash';

/**
 * @param {object} props - whether or not the switch is checked, optional extra css and any other react-switch params
 * @returns {node} an accessible switch component that follows the Starfish style guide
 */
const Switch = (props) => {
    return <ReactSwitch {...omit(props, ['extraCss'])}
                        checkedIcon={<Icon icon="done" aria-hidden={true} />}
                        className={classnames(css['toggle'], {
                            [css.checked]: props.checked,
                            [css.unchecked]: !props.checked,
                            [props.extraCss]: !isEmptyString(props.extraCss)
                        })}
                        uncheckedIcon={false} />
};

Switch.propTypes = {
    checked: PropTypes.bool.isRequired,
    extraCss: PropTypes.string
};

export default Switch;
